export default __webpack_public_path__ + "static/ni-fd9face739924d86e377340a23ac158f.svg";